import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SelectItem } from 'src/app/modules/shared/components/custom-select/select-item';

@Component({
  selector: 'app-shows-status-select',
  templateUrl: './shows-status-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowsStatusSelectComponent implements OnChanges {
  typeSelect: string = 'Status: '
  @Input() active?: boolean;
  @Input() type = ''
  @Output() activeChange = new EventEmitter<boolean | undefined>();

  selected?: SelectItem<boolean | undefined>;
  status: SelectItem<boolean | undefined>[] = [
    {
      label: `Todos`,
      value: undefined
    },
    {
      label: 'Ativos',
      value: true
    },
    {
      label: 'Desativados',
      value: false
    }
  ] ;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.active) {
      this.selected = this.status?.find(
        (select) => select.value === this.active
      );
    }
  }

  change(selectedItem: SelectItem<boolean | undefined>): void {
    this.active = selectedItem.value;
    this.selected = selectedItem;
    this.activeChange.emit(this.active);
  }
}
